export const Close = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.68799 8.68799L23.3119 23.3119" stroke="currentColor" stroke-width="2"/>
  <path d="M23.312 8.68799L8.688 23.3119" stroke="currentColor" stroke-width="2"/>
</svg>`;
